import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const reviewSlice = createSlice({
  name: "reviewSlice",
  initialState: {
    loading: false,
    defaultReview: [],
    customReview: [],
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    getReviewList: (state, action) => {
      state.defaultReview = action.payload;
    },
    getCustomReviewList: (state, action) => {
      state.customReview = action.payload;
    },
  },
});

export const { getReviewList, getCustomReviewList, loading } = reviewSlice.actions;

export const getDefaultReview = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_default_package_review`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(getReviewList(data?.data));
    dispatch(loading(false));
  } catch (error) {
    toast.error(error?.response?.data?.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const updateDefaultReview = (id, pData) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_default_package_review/${id}`;
    const { data } = await axios.post(url, pData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(loading(false));
  } catch (error) {
    toast.error(error?.response?.data?.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const getCustomReview = () => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_customized_package_review`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(getCustomReviewList(data?.data));
    dispatch(loading(false));
  } catch (error) {
    toast.error(error?.response?.data?.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const updateCustomReview = (id, pData) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_customized_package_review/${id}`;
    const { data } = await axios.post(url, pData, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(loading(false));
  } catch (error) {
    toast.error(error?.response?.data?.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};
export default reviewSlice.reducer;
